module.exports = __webpack_public_path__ + "Icono_Cierre_Azul_512px.png";